import { render, staticRenderFns } from "./CargandoApp.vue?vue&type=template&id=054efd97&"
import script from "./CargandoApp.vue?vue&type=script&lang=js&"
export * from "./CargandoApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports